import * as reducers from './ducks';

export default { reducers };
